import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import borderMixin from 'styles/utils/borderMixin';
import { IconButton } from '../Button/Button';
import { DismissCircleRegular } from '@fluentui/react-icons';
import { makeStyles } from '@fluentui/react-components';
import { p4Tokens } from '../../../styles/themes/default/p4FluentTheme';

const Div = styled.textarea`
  display: inline-block;
  width: 100%;
  height: ${(props) => (props.height ? props.height : '110px')};
  padding: 0.375rem 0.2rem 0rem 0rem;
  font-size: 15px;
  line-height: 1.4375;
  color: ${p4Tokens.colorNeutralForeground1};
  background-color: ${p4Tokens.colorNeutralBackground1};
  background-image: none;
  vertical-align: middle;
  resize: none;
  ${borderMixin} &:disabled {
    cursor: not-allowed;
  }
`;

const TextArea = React.forwardRef((props, ref) => {
  const { id, disabled, handleChange, onChange, onRowClick, value, clearable, ...rest } = props;

  const onClickClear = useCallback(() => {
    onChange('');
  }, [onChange]);

  const textArea = (
    <Div
      autoComplete="off"
      disabled={disabled}
      key={id}
      onChange={onChange ?? handleChange}
      ref={ref}
      value={value || ''}
      {...rest}
    />
  );

  if (clearable) {
    return (
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        {textArea}
        <IconButton
          icon={<DismissCircleRegular onClick={onClickClear} />}
          wrapperStyle={{
            padding: 0,
          }}
        />
      </div>
    );
  }

  return textArea;
});

TextArea.propTypes = {
  disabled: PropTypes.bool,
  handleChange: PropTypes.func,
  id: PropTypes.string.isRequired,
};
TextArea.defaultProps = {
  disabled: false,
  handleChange: () => {},
  id: '',
};

export default TextArea;
